import React, { useContext, useMemo } from 'react';
import { Box, Flex } from 'rebass';
import { ButtonStyled, TextStyled, useTokens } from '@nike/nike-design-system-components';

import { TableServerSideContext } from '~COMPONENTS/tableServerSide/TableServerSideContext';
import TableServerSide from '../../components/tableServerSide/TableServerSide';
import IconMenu from '../../components/IconMenu';
import { ContractGroupModal } from './modals';

import { getProductContractGroupsColumns } from './columns';

import useModal from '../../hooks/useModal';

const ProductContractGroups = () => {
  const tokens = useTokens();

  const memoizedColumns = useMemo(() => getProductContractGroupsColumns(), []);

  const [isCreateContractGroupModalOpen, openCreateContractGroupModal, closeCreateContractGroupModal] = useModal();

  const { totalResources, handleClearSortAndFilters } = useContext(TableServerSideContext);

  return (
    <Box style={{ backgroundColor: tokens.podiumCdsColorGrey50 }}>
      <Flex
        sx={{
          borderBottom: `1px solid ${tokens.podiumCdsColorGrey200}`,
          padding: '12px',
          width: '100%'
        }}
      >
        <TextStyled appearance='title2'>Product Contract Groups</TextStyled>
      </Flex>
      <Flex p='12px' width='100%'>
        <Flex alignItems='center' width='50%'>
          <TextStyled appearance='body2' style={{ marginLeft: '5px' }}>
            {`${totalResources}`} results
          </TextStyled>

          <ButtonStyled
            appearance='text'
            background='light'
            ariaLabel='Clear All Filters'
            type='button'
            onClick={handleClearSortAndFilters}
            style={{ marginLeft: '20px', marginRight: '20px' }}
          >
            Clear All Filters
          </ButtonStyled>
        </Flex>

        <Flex justifyContent='flex-end' width='50%'>
          <IconMenu
            align='right'
            menuOptions={[{ text: 'Create Contract Group', onClick: openCreateContractGroupModal }]}
          />
        </Flex>
      </Flex>

      <Box px='12px'>
        <TableServerSide columns={memoizedColumns} url='v1/contractGroups' fullHeight fullWidth />
      </Box>

      {isCreateContractGroupModalOpen && (
        <ContractGroupModal
          actionName='Create Group'
          closeModal={closeCreateContractGroupModal}
          isOpen={isCreateContractGroupModalOpen}
          title='Create A New Contract Group'
          type='create'
        />
      )}
    </Box>
  );
};

export default ProductContractGroups;
